<template>
  <div>
    <div>
      <v-simple-table>
        <template v-slot:default>
          <tbody>
            <component
              v-for="([name, node], index) in relevantNodes"
              :key="index"
              :name="name"
              :description="name"
              :variables="variables"
              :deviceType="currentObject.assetInfo.deviceType"
              :node="node"
              :fullShvPath="fullShvPath"
              :types="types"
              :is="chooseComponent(node)"
            >
            </component>
          </tbody>
        </template>
      </v-simple-table>
    </div>
    <div v-if="abReasons.length > 0">
      {{ $t('zone.abReasons') }}
      <v-simple-table>
        <template v-slot:default>
          <tbody>
            <component
              v-for="([name, node], index) in abReasons"
              :key="index"
              :name="name"
              :description="name"
              :deviceType="currentObject.assetInfo.deviceType"
              :node="node"
              :variables="variables"
              :fullShvPath="fullShvPath"
              :types="types"
              :is="chooseComponent(node)"
            >
            </component>
          </tbody>
        </template>
      </v-simple-table>
    </div>
    <div v-if="eiReasons.length > 0">
      {{ $t('zone.eiReasons') }}
      <v-simple-table>
        <template v-slot:default>
          <tbody>
            <component
              v-for="([name, node], index) in eiReasons"
              :key="index"
              :name="name"
              :description="name"
              :deviceType="currentObject.assetInfo.deviceType"
              :node="node"
              :variables="variables"
              :fullShvPath="fullShvPath"
              :types="types"
              :is="chooseComponent(node)"
            >
            </component>
          </tbody>
        </template>
      </v-simple-table>
    </div>
  </div>
</template>

<style scoped>

</style>

<script>
import Vue from 'vue'
import NumberRow from './shv-3/number-row.vue'
import DefaultRow from './shv-3/default-row.vue'
import AlarmRow from './shv-3/alarm-row.vue'
import SetRow from './shv-3/set-row.vue'
import { mapState } from 'vuex'
import { parseStatusNode } from './shv-3/utils.js'

export default Vue.extend({
  name: 'default-property-sheet',
  props: {
    assetNodes: {},
    currentObject: {},
    variables: {},
    currentAssetPath: {},
    fullShvPath: undefined,
    types: {}
  },

  data () {
    return {
      showDebugDetail: false
    }
  },

  updated () {
    console.log('UPDATED!!!!!!!!!!')
  },

  computed: {
    ...mapState('tygroshka', [
      'shvData',
      'translations'
    ]),

    relevantNodes () {
      const blacklistedPaths = this.shvData.blacklistedPaths
      return this.parsedNodes.filter(([_name, n]) => {
        const fullNodePath = `${this.currentAssetPath}/${n.fullNodePath}`
        const blacklisted = blacklistedPaths.includes(fullNodePath)
        const reasonBits = n.parentType === 'ZoneReasonBitsAB' || n.parentType === 'ZoneReasonBitsEI'
        return (n.typeName || n.unit) && !blacklisted && !reasonBits
      })
    },

    abReasons () {
      return this.parsedNodes.filter(([name, n]) => {
        return n.parentType === 'ZoneReasonBitsAB' && this.variables.get(`ZoneReasonBitsAB/${name}`)
      })
    },

    eiReasons () {
      return this.parsedNodes.filter(([name, n]) => {
        return n.parentType === 'ZoneReasonBitsEI' && this.variables.get(`ZoneReasonBitsEI/${name}`)
      })
    },

    // transform all status nodes to normal nodes through bitfield
    parsedNodes () {
      // console.log('ASSET NODES', this.assetNodes)
      return this.assetNodes.flatMap(node => {
        return parseStatusNode(node.name, node, this.types, this.translations)
      })
    }
  },

  methods: {
    splitAndSlice (nodePath) {
      const splittedPath = nodePath.split('/')
      return splittedPath.slice(1, splittedPath.length).join('/')
    },

    chooseComponent (node) {
      const isNumber = /Decimal/.test(node.typeName) || node.typeName === 'Int' || node.typeName === 'UInt'
      const hasSetMethod = node.methods.filter(m => m.name === 'set').length > 0
      // console.log('decide which component to use', node)
      // return 'number-row'
      if (hasSetMethod) {
        return 'set-row'
      } else if (node.alarm) {
        return 'alarm-row'
      } else if (isNumber) {
        return 'number-row'
      } else {
        return 'default-row'
      }
    }
  },

  components: {
    NumberRow,
    DefaultRow,
    AlarmRow,
    SetRow
  }
})
</script>
